module.exports = __webpack_public_path__ + "static/media/Appstore button.bd4fb198.webp";